import {NgModule} from '@angular/core';

import {HeadingQuillToolbarButtonComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the HeadingQuillToolbarButtonModule
 * @class
 */
@NgModule({
  declarations: [HeadingQuillToolbarButtonComponent],
  exports: [HeadingQuillToolbarButtonComponent],
  imports: [IonicModule],
  providers: [],
})
export class HeadingQuillToolbarButtonModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/heading-quill-toolbar-button/heading-quill-toolbar-button.component.module.ts